
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

// Task data
const recentTasks = [
  { id: 1, title: "RBI Quarterly Return Filing", dueDate: "2025-05-15", status: "pending", priority: "high" },
  { id: 2, title: "Financial Covenant Verification", dueDate: "2025-05-10", status: "in-progress", priority: "medium" },
  { id: 3, title: "Asset Liability Report", dueDate: "2025-05-08", status: "pending", priority: "high" },
  { id: 4, title: "Update Credit Policy", dueDate: "2025-05-20", status: "pending", priority: "low" },
];

const TasksList: React.FC = () => {
  return (
    <Card>
      <Tabs defaultValue="pending">
        <CardHeader className="pb-0">
          <CardTitle>Recent Tasks</CardTitle>
          <TabsList>
            <TabsTrigger value="pending">Pending</TabsTrigger>
            <TabsTrigger value="all">All Tasks</TabsTrigger>
          </TabsList>
        </CardHeader>
        <CardContent className="pt-4">
          <TabsContent value="pending" className="space-y-4">
            {recentTasks.map((task) => (
              <div key={task.id} className="task-item">
                <div>
                  <h4 className="font-medium">{task.title}</h4>
                  <p className="text-sm text-muted-foreground">Due: {task.dueDate}</p>
                </div>
                <div className={`px-2 py-1 text-xs rounded-full ${
                  task.priority === 'high' 
                    ? 'bg-red-100 text-red-800' 
                    : task.priority === 'medium'
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-blue-100 text-blue-800'
                }`}>
                  {task.priority}
                </div>
              </div>
            ))}
          </TabsContent>
          <TabsContent value="all" className="space-y-4">
            <p className="text-sm text-muted-foreground">View all 24 tasks in the Tasks section.</p>
          </TabsContent>
        </CardContent>
      </Tabs>
    </Card>
  );
};

export default TasksList;
